<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 511.844 511.844"
>
  <path
    d="M447.864 223.94H63.982c-5.889 0-10.669 4.772-10.669 10.661s4.78 10.66 10.669 10.66h383.882c5.889 0 10.668-4.771 10.668-10.66s-4.779-10.661-10.668-10.661z"
    fill="#965353"
  />
  <path
    d="M245.255 10.669v490.523c0 5.889 4.78 10.652 10.669 10.652 5.888 0 10.667-4.764 10.667-10.652V10.669h-21.336z"
    fill="#965353"
  />
  <path
    d="M351.894 106.64c0 52.999-42.971 95.971-95.97 95.971s-95.971-42.972-95.971-95.971c0-53.008 42.971-95.971 95.971-95.971s95.97 42.963 95.97 95.971z"
    fill="#f4be8e"
  />
  <path
    d="M335.9 20.697C333.056 9.317 321.122 0 309.392 0h-106.64c-11.731 0-23.649 9.317-26.492 20.697l-10.981 54.584c-2.843 11.38 4.42 20.689 16.151 20.689h149.297c11.73 0 18.994-9.31 16.152-20.689L335.9 20.697z"
    fill="#f5ba45"
  />
  <path
    d="M330.571 202.61c-11.73 0-28.49 6.396-37.238 14.206 0 0-7.967 7.123-37.41 7.123-29.444 0-37.411-7.123-37.411-7.123-8.748-7.81-25.508-14.206-37.239-14.206h-63.98c-11.73 0-21.321 9.599-21.321 21.329v42.651c0 11.731 9.591 21.321 21.321 21.321h24.196c11.731 0 22.509 9.529 23.946 21.166l13.23 106.967c1.437 11.637 12.199 21.166 23.93 21.166h106.64c11.73 0 22.523-9.529 23.977-21.166l13.34-106.967c1.453-11.637 12.23-21.166 23.961-21.166h24.039c11.732 0 21.322-9.59 21.322-21.321v-42.651c0-11.73-9.59-21.329-21.322-21.329h-63.981z"
    fill="#808080"
    data-player="true"
  />
  <path
    d="M394.396 85.31c0-5.787-4.607-10.48-10.355-10.645v-.016H128.118c-5.889 0-10.668 4.771-10.668 10.66 0 5.89 4.78 10.661 10.668 10.661H384.04v-.008c5.748-.171 10.356-4.864 10.356-10.652z"
    fill="#fecd57"
  />
</svg>
